export default "__VITE_ASSET__b2cc834f__"